export const MAIN_BRANCH_NAME = "main";

export function branchNameError(name: string): string | null {
  const trimmed = name.trim();
  if (!trimmed) return "Name can’t be empty.";
  if (trimmed.toLowerCase() === MAIN_BRANCH_NAME)
    return "“main” is a reserved branch name.";
  return null;
}
